import { forwardRef } from 'react';
import { MdPerson } from 'react-icons/md';
import {
  Button,
  Icon,
  IconContainer,
  Input,
  useToastNotifications,
} from '@nbirl/nbi-common-ui-libs';
import classNames from 'classnames';

type ShareLinkProps = { link: string; compact?: boolean };

export const ShareLink = forwardRef<HTMLButtonElement, ShareLinkProps>(
  ({ link, compact }, focusButtonRef) => {
    const { addToast } = useToastNotifications();

    const handleCopy = async () => {
      await navigator.clipboard.writeText(link);

      addToast({
        variant: 'info',
        text: 'Link copied',
        duration: 2000,
      });
    };

    return (
      <div className="space-y-8 mt-10">
        <div className="flex space-x-2">
          <Input
            readOnly
            defaultValue={link}
            onFocus={(event) => event.target.select()}
          />

          <Button
            ref={focusButtonRef}
            variant="ghost"
            className="flex-none"
            onClick={handleCopy}
          >
            Copy link
          </Button>
        </div>

        <div className="flex items-center space-x-4">
          {!compact && (
            <IconContainer variant="light">
              <Icon icon={<MdPerson />} />
            </IconContainer>
          )}

          <div className={classNames({ 'flex space-x-3 text-sm': compact })}>
            <div className="font-medium">Restricted</div>
            <div className="text-sm">
              Only people with access to the folder can open this link
            </div>
          </div>
        </div>
      </div>
    );
  }
);
